module.exports = __webpack_public_path__ + "static/media/navbar-ico-5-active.a8a08794.svg";